import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { brandArticles } from "@/mocks/brandArticles";

export default function SeoContent() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="flex-1 lg:max-w-[45%]">
            <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300 text-foreground-600 text-xs font-medium mb-5 whitespace-nowrap">
              {t("seo.badge")}
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-foreground-950 mb-2 leading-tight">
              {t("seo.title1")}
            </h2>
            <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-foreground-700 mb-8 leading-tight">
              {t("seo.title2")}
            </h2>

            <div className="prose prose-sm max-w-none text-foreground-700 leading-relaxed space-y-5">
              <h3 className="text-xl font-heading font-bold text-foreground-950 !mb-3">
                Kakobuy Spreadsheet — Najlepszy Sposób na Znajdowanie Produktów
              </h3>
              <p>
                <strong>Kakobuy Spreadsheet</strong> to zaawansowane narzędzie, które rewolucjonizuje sposób,
                w jaki kupujący znajdują produkty online. Dzięki rozbudowanemu <strong>arkuszowi Kakobuy</strong>,
                użytkownicy z całej Polski mogą szybko i sprawnie przeglądać tysiące produktów w jednym miejscu.
                Nasz <strong>spreadsheet</strong> jest codziennie aktualizowany, co gwarantuje dostęp do
                najświeższych ofert i najlepszych okazji na rynku.
              </p>

              <h3 className="text-xl font-heading font-bold text-foreground-950 !mb-3">
                Dlaczego Warto Korzystać z Kakobuy Spreadsheet?
              </h3>
              <p>
                Korzystanie z <strong>Kakobuy Spreadsheet</strong> niesie ze sobą wiele korzyści. Przede
                wszystkim oszczędzasz czas — zamiast przeszukiwać dziesiątki stron, wszystkie produkty
                znajdziesz w jednym, przejrzystym <strong>arkuszu</strong>. Ponadto, nasz
                <strong> spread</strong> zawiera tylko sprawdzone i zweryfikowane oferty od zaufanych
                sprzedawców. Każdy produkt w <strong>Kakobuy spreadsheet</strong> przechodzi kontrolę
                jakości, dzięki czemu masz pewność, że otrzymujesz to, za co płacisz.
              </p>

              <h3 className="text-xl font-heading font-bold text-foreground-950 !mb-3">
                Najpopularniejsze Kategorie w Naszym Arkuszu
              </h3>
              <p>
                W naszym <strong>Kakobuy Spreadsheet</strong> znajdziesz produkty z najróżniejszych
                kategorii. Od <strong>butów</strong> przez <strong>bluzy</strong>, <strong>koszulki</strong>,
                <strong> kurtki</strong>, aż po <strong>akcesoria</strong> i <strong>perfumy</strong>.
                Każda kategoria jest starannie posegregowana, a produkty są regularnie aktualizowane.
                Dzięki temu <strong>spreadsheet zakupowy</strong> jest zawsze aktualny i gotowy do użycia.
                Niezależnie od tego, czy szukasz <strong>Nike</strong>, <strong>Adidas</strong>,
                <strong> Stussy</strong> czy <strong>Essentials</strong> — nasz arkusz ma wszystko.
              </p>

              <h3 className="text-xl font-heading font-bold text-foreground-950 !mb-3">
                Jak Korzystać z Kakobuy Spreadsheet?
              </h3>
              <p>
                Korzystanie z <strong>Kakobuy Spreadsheet</strong> jest niezwykle proste. Wystarczy wybrać
                interesującą Cię kategorię z menu lub z listy poniżej, a zostaniesz przekierowany
                bezpośrednio do odpowiedniej sekcji <strong>arkusza</strong>. Cały proces zajmuje
                zaledwie kilka sekund. Nasz <strong>spreadsheet Kakobuy</strong> został zaprojektowany
                z myślą o maksymalnej wygodzie użytkownika, dlatego nawigacja jest intuicyjna,
                a wszystkie linki prowadzą bezpośrednio do produktów na stronie głównej.
              </p>

              <h3 className="text-xl font-heading font-bold text-foreground-950 !mb-3">
                Bezpieczeństwo i Zaufanie
              </h3>
              <p>
                Bezpieczeństwo jest dla nas priorytetem. Wszystkie produkty w <strong>Kakobuy Spreadsheet</strong>
                pochodzą od sprawdzonych sprzedawców, a każdy link jest weryfikowany przed dodaniem do
                <strong> arkusza</strong>. Nasz zespół regularnie sprawdza aktualność ofert, abyś Ty
                nie musiał się tym martwić. <strong>Kakobuy spreadsheet Polska</strong> to zaufane
                źródło dla tysięcy kupujących, którzy codziennie korzystają z naszego narzędzia
                do znajdowania najlepszych okazji.
              </p>

              <div className="pt-4 flex flex-col gap-3">
                <Link
                  to="/kakobuy-sheet-przewodnik"
                  className="inline-flex items-center gap-2 text-primary-600 font-semibold text-sm hover:text-primary-700 transition-colors cursor-pointer"
                >
                  {t("seo.button")}
                </Link>

                <div className="pt-2 border-t border-background-200">
                  <p className="text-xs font-semibold text-foreground-500 mb-3 uppercase tracking-wide">
                    Przewodniki po Arkuszach:
                  </p>
                  <div className="grid grid-cols-2 gap-2">
                    {brandArticles.map((ba) => (
                      <Link
                        key={ba.slug}
                        to={`/${ba.slug}`}
                        className="text-xs text-foreground-600 hover:text-primary-600 transition-colors underline cursor-pointer"
                      >
                        {ba.brandName} Spreadsheet
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 lg:max-w-[55%] flex flex-col gap-6">
            <div className="flex gap-4 items-start">
              <div className="flex-1 flex flex-col gap-4">
                <div className="rounded-2xl overflow-hidden bg-background-200 aspect-[4/3]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20still%20life%20editorial%20photography%20of%20carefully%20folded%20linen%20shirts%20and%20cotton%20garments%20stacked%20neatly%20on%20a%20rustic%20weathered%20wood%20shelf%2C%20warm%20afternoon%20sunlight%20streaming%20through%20nearby%20window%20creating%20gentle%20highlights%2C%20sage%20green%20eucalyptus%20branches%20in%20ceramic%20vase%20adding%20organic%20freshness%2C%20slow%20living%20aesthetic%20with%20natural%20material%20textures%2C%20premium%20lifestyle%20catalog%20mood%2C%20serene%20and%20mindful%20atmosphere&width=600&height=450&seq=seo-img-01-v2&orientation=landscape"
                    alt="Kakobuy Spreadsheet - produkty"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="rounded-2xl overflow-hidden bg-background-200 aspect-[16/9]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Curated%20overhead%20composition%20of%20minimalist%20fashion%20accessories%20including%20a%20leather%20belt%20watch%20and%20canvas%20tote%20bag%20arranged%20on%20warm%20cognac%20leather%20desk%20mat%2C%20soft%20morning%20light%20from%20skylight%20above%2C%20rich%20earth%20tones%20of%20chestnut%20brown%20deep%20tan%20and%20warm%20sand%2C%20refined%20menswear%20editorial%20aesthetic%2C%20high%20detail%20showing%20leather%20patina%20and%20brass%20hardware%2C%20sophisticated%20gentleman%20style%20photography&width=600&height=340&seq=seo-img-02-v2&orientation=landscape"
                    alt="Kakobuy Spreadsheet - akcesoria"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="flex-1 flex flex-col gap-4 pt-8">
                <div className="rounded-2xl overflow-hidden bg-background-200 aspect-[3/5]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Vertical%20editorial%20fashion%20portrait%20of%20a%20styled%20outfit%20featuring%20an%20oversized%20knit%20sweater%20in%20warm%20rust%20color%20paired%20with%20cream%20wide%20leg%20trousers%2C%20hanging%20elegantly%20on%20a%20minimalist%20wooden%20hanger%20against%20soft%20peach%20plaster%20wall%2C%20gentle%20natural%20light%20from%20side%20window%2C%20effortless%20sophisticated%20aesthetic%20with%20Japanese%20and%20Scandinavian%20influences%2C%20high%20fashion%20catalog%2C%20rich%20textural%20contrast%20between%20chunky%20knit%20and%20smooth%20fabric&width=450&height=750&seq=seo-img-03-v2&orientation=portrait"
                    alt="Kakobuy Spreadsheet - stylizacje"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}